// @flow
import * as React from 'react';
import cuid from 'cuid';

import Dropdown from '../Dropdown';
import { ActionBarStateConsumer } from '../../context/actionBarState.context';
import type { CommonActionProps } from './types.actions';
import { DesktopView } from '../../config/mediaQuery';

export default class StateSelector extends React.Component<CommonActionProps> {
  render() {
    return (
      <ActionBarStateConsumer>
        {({ onChangeMonth, month, months }: any) => {
          if (!onChangeMonth) return null;

          return (
            <DesktopView>
              {(isDesktop) => (
                <Dropdown
                  disabled={this.props.disabled}
                  onChange={onChangeMonth}
                  selected={month}
                  options={months}
                  id={cuid()}
                  title={isDesktop ? "Month" : null}
                />
              )}
            </DesktopView>
          );
        }}
      </ActionBarStateConsumer>
    );
  }
}
